import { Routes, Route, BrowserRouter as Router } from "react-router";
import Home from "./page/home/Home";
import Document from "./page/document/Document";
import Statment from "./page/statment/Statment";
import Download from "./component/download/download";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/download" element={<Download />} />
        <Route path="/Document/:document_id" element={<Document />} />
        <Route path="/Statment/:statment_number" element={<Statment />} />
      </Routes>
    </Router>
  );
}

export default App;
